module.exports = __webpack_public_path__ + "static/media/mainimg-03.ac2b5d2c.png";